export default "<es-onboarding-page on-close=\"vm.redirectToPage\"></es-onboarding-page>\n"